export const getHeader = ({ colors }) => ({
  tabs: {
    colors: {
      active: {
        color: colors.gray[950],
      },
    },
  },
})
